import React from 'react';

import {
  Flex,
  Panel,
  InfoSection,
  Divider
} from '@sopranodesign/pulse-components';

import InitialOpenSettings from './InitialOpenSettings';
import RenderSettings from './RenderSettings';

const DisplaySettings = () => {
  return (
    <Flex top>
      <Panel>
        <InfoSection
          mtNone
          title="Display Rules"
          info="Create smart rules to control the visibility of your chat widget."
        />
        <Divider />
        <Flex col ySpace>
          <RenderSettings />
          <InitialOpenSettings />
        </Flex>
      </Panel>
    </Flex>
  );
};

export default DisplaySettings;
